<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_your_champions' | translate: lang }}</h5>
  <button
    (click)="verifySelectedChampions()"
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
  >
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="champion-selector">
    <div class="champion-select-header">
      <div class="form-group">
        <input #searchInput
               (keyup)="filterChampions($event)"
               type="text"
               class="form-control champion-list-search"
               placeholder="{{ 'search' | translate: lang }}"
        >
      </div>
      <div class="champion-select-information" *ngIf="type === 'solo' && game === 'lol'">
        <!-- <p><small>Selecting 4+ champions is free. A {{ extraServiceCharactersTax }}% fee is added for choosing 1 to 3.</small></p> -->
        <p><small>{{ ('champ_selection_info' | translate: lang).replace('{{REPLACE}}', extraServiceCharactersTax)  }}</small></p>
        <div>
          <small>{{ 'current_selection' | translate: lang }}: <span class="champion-select-value" [ngClass]="{'paid': currentSelectedChampions.length > 0 && currentSelectedChampions.length < 4}">{{ currentSelectedChampions.length > 0 && currentSelectedChampions.length < 4 ? extraServiceCharactersTax + '%' : ('free' | translate: lang ) }}</span></small>
        </div>
      </div>
    </div>
    <div class="champion-list">
      <div class="champion-item" *ngFor="let champion of availableChampions"
        (click)="toggleChampionSelection(champion.name)"
        [class.active]="currentSelectedChampions.indexOf(champion.name) > -1">
        <img alt="{{champion.name}}" src="https://cdn.ggboost.com/images/champions/{{ champion.name }}.jpg"
          class="champion-avatar">
      </div>
    </div>
  </div>

  <app-button size="form" [block]="true" (clicked)="verifySelectedChampions()">{{ 'confirm' | translate: lang }}</app-button>
</div>